/*
 * Savile Standard — theme.js
 * Vanilla JS, no dependencies. Never writes HTML strings into the page:
 * every dynamic value goes through textContent or setAttribute.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('ThemeConfig');
  var config = { routes: {}, strings: {} };
  try {
    if (configEl) config = JSON.parse(configEl.textContent);
  } catch (e) { /* keep defaults */ }

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function qs(selector, root) { return (root || document).querySelector(selector); }
  function qsa(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }

  /* ---------- Toast ---------- */

  var toastTimer;
  function showToast(message, withCartLink) {
    var toast = qs('[data-toast]');
    if (!toast) return;
    while (toast.firstChild) toast.removeChild(toast.firstChild);
    var text = document.createElement('span');
    text.textContent = message;
    toast.appendChild(text);
    if (withCartLink && config.routes.cart_url) {
      var link = document.createElement('a');
      link.href = config.routes.cart_url;
      link.textContent = config.strings.viewCart || 'View cart';
      toast.appendChild(link);
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4500);
  }

  /* ---------- Cart ---------- */

  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) { el.textContent = String(count); });
  }

  function refreshCartCount() {
    if (!config.routes.cart_url) return Promise.resolve();
    return fetch(config.routes.cart_url + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); })
      .catch(function () {});
  }

  function addToCart(items, toCheckout) {
    var body = { items: items };
    /* with the drawer, Shopify sends the freshly rendered drawer back with the same request */
    if (drawerOn() && !toCheckout) { body.sections = 'cart-drawer'; body.sections_url = window.location.pathname; }
    return fetch(config.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          var err = new Error((data && (data.description || data.message)) || config.strings.error);
          throw err;
        }
        return data;
      });
    });
  }

  function afterAdd(data) {
    if (showAdded(data)) return;
    if (config.cartAfterAdd === 'page' && config.routes.cart_url) {
      window.location.href = config.routes.cart_url;
      return;
    }
    refreshCartCount();
    showToast(config.strings.added || 'Added to your cart.', true);
  }


  /* ---------- Cart drawer and free shipping bar ----------
     The drawer's content comes from Shopify's Section Rendering API: the store renders the
     cart-drawer section and theme.js swaps in the part inside [data-cart-drawer-inner]. That
     markup is the theme's own Liquid output, never text typed by a shopper. */

  var drawerOpener = null;
  function getDrawer() { return qs('[data-cart-drawer]'); }
  function drawerOn() { return config.cartAfterAdd === 'drawer' && !!getDrawer(); }

  function formatMoney(cents, currency) {
    var lang = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  /* Draws every free shipping bar in root. The threshold is in the store's currency; for a
     shopper paying in another one it is converted with Shopify's rate and the text rewritten.
     fromPct makes the fill grow from the previous level instead of jumping. */
  function drawShipping(root, fromPct) {
    qsa('[data-free-shipping]', root).forEach(function (bar) {
      var threshold = Number(bar.getAttribute('data-threshold')) || 0;
      var total = Number(bar.getAttribute('data-total')) || 0;
      var currency = bar.getAttribute('data-currency');
      var shopCurrency = bar.getAttribute('data-shop-currency');
      var rate = 1;
      if (!bar.hasAttribute('data-threshold-local') && currency && shopCurrency && currency !== shopCurrency && window.Shopify && window.Shopify.currency) {
        rate = Number(window.Shopify.currency.rate) || 1;
      }
      var goal = Math.round(threshold * rate);
      var remaining = goal - total;
      var pct = goal > 0 ? Math.max(0, Math.min(100, Math.floor(total / goal * 100))) : 100;
      var text = qs('[data-free-shipping-text]', bar);
      var fill = qs('[data-free-shipping-fill]', bar);
      var track = qs('[data-free-shipping-track]', bar);
      if (rate !== 1 && text) {
        text.textContent = remaining > 0
          ? String(config.strings.freeShippingRemaining || '').replace('[amount]', formatMoney(remaining, currency))
          : (config.strings.freeShippingUnlocked || '');
      }
      bar.classList.toggle('is-unlocked', remaining <= 0);
      if (track) track.setAttribute('aria-valuenow', String(pct));
      if (!fill) return;
      if (typeof fromPct === 'number' && !reducedMotion && fromPct !== pct) {
        fill.style.transition = 'none';
        fill.style.width = fromPct + '%';
        void fill.offsetWidth;
        fill.style.transition = '';
      }
      fill.style.width = pct + '%';
    });
  }
  drawShipping(document);

  function drawerPct() {
    var drawer = getDrawer();
    var fill = drawer && qs('[data-free-shipping-fill]', drawer);
    return fill ? parseFloat(fill.style.width) || 0 : 0;
  }

  function renderDrawer(html) {
    var drawer = getDrawer();
    if (!drawer || !html) return false;
    var fresh = qs('[data-cart-drawer-inner]', new DOMParser().parseFromString(html, 'text/html'));
    var inner = qs('[data-cart-drawer-inner]', drawer);
    if (!fresh || !inner) return false;
    var from = drawerPct();
    var hadFocus = inner.contains(document.activeElement) ? document.activeElement : null;
    var focusKey = hadFocus && hadFocus.closest('[data-line-key]') ? hadFocus.closest('[data-line-key]').getAttribute('data-line-key') : null;
    var focusRole = hadFocus ? hadFocus.getAttribute('data-cart-qty-change') !== null && hadFocus.textContent.trim() : null;
    inner.parentNode.replaceChild(document.importNode(fresh, true), inner);
    drawShipping(drawer, from);
    /* keep keyboard focus on the same control after a quantity change */
    if (hadFocus) {
      var line = focusKey ? qs('[data-line-key="' + focusKey + '"]', drawer) : null;
      var target = null;
      if (line) qsa('[data-cart-qty-change]', line).forEach(function (b) { if (b.textContent.trim() === focusRole) target = b; });
      (target || qs('[data-cart-drawer-panel]', drawer)).focus();
    }
    return true;
  }

  function refreshDrawer() {
    var root = config.routes.root_url || '/';
    return fetch(root + (root.slice(-1) === '/' ? '' : '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data && data['cart-drawer']); })
      .catch(function () {});
  }

  function focusables(el) {
    return qsa('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])', el)
      .filter(function (node) { return node.offsetWidth || node.offsetHeight || node.getClientRects().length; });
  }

  function openDrawer(opener) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawerOpener = opener || document.activeElement;
    drawer.classList.add('is-open');
    document.documentElement.classList.add('cart-drawer-open');
    qsa('[data-cart-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = qs('[data-cart-drawer-panel]', drawer);
    setTimeout(function () { if (panel) panel.focus({ preventScroll: true }); }, 60);
  }

  function closeDrawer() {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cart-drawer-open');
    qsa('[data-cart-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (drawerOpener && document.contains(drawerOpener)) drawerOpener.focus({ preventScroll: true });
    drawerOpener = null;
  }

  /* After an add: with the drawer, show it (already rendered by the add request when possible) */
  function showAdded(data, opener) {
    if (!drawerOn()) return false;
    refreshCartCount();
    var html = data && data.sections && data.sections['cart-drawer'];
    if (html && renderDrawer(html)) openDrawer(opener);
    else refreshDrawer().then(function () { openDrawer(opener); });
    return true;
  }

  function changeLine(key, quantity) {
    var drawer = getDrawer();
    var inner = drawer && qs('[data-cart-drawer-inner]', drawer);
    if (inner) inner.classList.add('is-busy');
    return fetch((config.routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && (data.description || data.message)) || config.strings.error);
        return data;
      });
    }).then(function (data) {
      if (typeof data.item_count === 'number') setCartCount(data.item_count);
      if (!renderDrawer(data.sections && data.sections['cart-drawer'])) return refreshDrawer();
    }).catch(function (err) {
      var current = qs('[data-cart-drawer-inner]', getDrawer());
      if (current) current.classList.remove('is-busy');
      var box = current && qs('[data-cart-drawer-error]', current);
      if (box) { box.textContent = err.message || config.strings.error || ''; box.hidden = false; }
    });
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cart-drawer-open]');
    if (opener && drawerOn()) {
      event.preventDefault();
      openDrawer(opener);
      refreshDrawer();
      return;
    }
    var drawer = getDrawer();
    if (!drawer || !drawer.contains(event.target)) return;
    if (event.target.closest('[data-cart-drawer-close]')) { closeDrawer(); return; }
    var step = event.target.closest('[data-cart-qty-change]');
    if (step) {
      var line = step.closest('[data-line-key]');
      if (line) changeLine(line.getAttribute('data-line-key'), Math.max(0, parseInt(step.getAttribute('data-cart-qty-change'), 10) || 0));
    }
  });

  document.addEventListener('keydown', function (event) {
    var drawer = getDrawer();
    if (!drawer || !drawer.classList.contains('is-open')) return;
    if (event.key === 'Escape') { closeDrawer(); return; }
    if (event.key !== 'Tab') return;
    var items = focusables(qs('[data-cart-drawer-panel]', drawer));
    if (!items.length) { event.preventDefault(); return; }
    var first = items[0], last = items[items.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === qs('[data-cart-drawer-panel]', drawer))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  /* the cart changed in another tab or after going back: keep the drawer in step */
  window.addEventListener('pageshow', function (event) { if (event.persisted && drawerOn()) { refreshDrawer(); refreshCartCount(); } });


  /* ---------- Country selector: switch to the country's own language ----------
     Picking a country also asks Shopify for that country's language (locale_code), when that
     language is published for the country's market. Countries with several languages (Belgium,
     Switzerland, Finland, Luxembourg, Canada) use the one the browser prefers, else the first. */
  var NATIVE_LANGUAGES = {
    AD: ['es'], AT: ['de'], AU: ['en'], BE: ['nl', 'fr', 'de'], BG: ['bg'], CA: ['en', 'fr'], CH: ['de', 'fr', 'it'],
    CY: ['el', 'en'], CZ: ['cs'], DE: ['de'], DK: ['da'], EE: ['et'], ES: ['es'], FI: ['fi', 'sv'], FR: ['fr'],
    GB: ['en'], GR: ['el'], HR: ['hr'], HU: ['hu'], IE: ['en'], IS: ['en'], IT: ['it'], LI: ['de'], LT: ['lt'],
    LU: ['fr', 'de'], LV: ['lv'], MC: ['fr'], MT: ['en'], NL: ['nl'], NO: ['nb', 'no'], NZ: ['en'], PL: ['pl'],
    PT: ['pt-PT', 'pt-BR', 'pt'], BR: ['pt-BR', 'pt'], AO: ['pt-PT', 'pt-BR', 'pt'], MZ: ['pt-PT', 'pt-BR', 'pt'], RO: ['ro'], SE: ['sv'], SI: ['sl'], SK: ['sk'], SM: ['it'], US: ['en'], VA: ['it']
  };
  function pickLanguage(country, available) {
    var native = NATIVE_LANGUAGES[country] || [];
    var lower = available.map(function (code) { return code.toLowerCase(); });
    function find(code) { var i = lower.indexOf(code.toLowerCase()); if (i < 0) i = lower.indexOf(code.toLowerCase().split('-')[0]); return i > -1 ? available[i] : null; }
    var prefs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    for (var p = 0; p < prefs.length; p++) {
      var pref = String(prefs[p] || '').toLowerCase();
      for (var n = 0; n < native.length; n++) {
        if (pref === native[n].toLowerCase() || pref.split('-')[0] === native[n].toLowerCase().split('-')[0]) {
          var hit = find(native[n]);
          if (hit) return hit;
        }
      }
    }
    for (var k = 0; k < native.length; k++) { var found = find(native[k]); if (found) return found; }
    return null;
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.localization-form button[name="country_code"]');
    if (!button || !button.form) return;
    var available = String(button.getAttribute('data-languages') || '').split(',').filter(Boolean);
    var language = pickLanguage(button.value, available);
    var input = qs('input[name="locale_code"]', button.form);
    if (!language) { if (input && input.hasAttribute('data-auto-locale')) input.disabled = true; return; }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'locale_code';
      input.setAttribute('data-auto-locale', '');
      button.form.appendChild(input);
    }
    input.disabled = false;
    input.value = language;
  });

  /* ---------- Disclosures (dropdowns, search, facets) ---------- */

  function closeDetails(details) {
    if (details && details.hasAttribute('open')) details.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    qsa('details[data-close-outside][open]').forEach(function (details) {
      if (!details.contains(event.target)) closeDetails(details);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    qsa('details[open]').forEach(function (details) {
      if (details.contains(document.activeElement) || details.hasAttribute('data-menu-drawer')) {
        closeDetails(details);
        var summary = qs('summary', details);
        if (summary) summary.focus();
      }
    });
  });

  // Only one header dropdown open at a time.
  qsa('.nav-dropdown').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (!details.open) return;
      qsa('.nav-dropdown[open]').forEach(function (other) { if (other !== details) closeDetails(other); });
    });
  });

  // Focus the search field when the search panel opens.
  qsa('.search-disclosure').forEach(function (details) {
    details.addEventListener('toggle', function () {
      if (details.open) {
        var input = qs('input[type="search"]', details);
        if (input) input.focus();
      }
    });
  });

  /* ---------- Mobile drawer ---------- */

  qsa('[data-menu-drawer]').forEach(function (drawer) {
    drawer.addEventListener('toggle', function () {
      document.documentElement.classList.toggle('scroll-lock', drawer.open);
    });
    qsa('[data-drawer-close]', drawer).forEach(function (button) {
      button.addEventListener('click', function () {
        closeDetails(drawer);
        var summary = qs('summary', drawer);
        if (summary) summary.focus();
      });
    });
  });

  /* ---------- Product card: gallery scrub + colour swatches ---------- */

  var canHoverScrub = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initCardScrub(media) {
    var images = qsa('[data-card-image]', media);
    var dots = qsa('.card__dot', media);
    var count = images.length;
    if (count < 2) return;
    var index = 0;

    function setIndex(next) {
      index = ((next % count) + count) % count;
      images.forEach(function (img, i) { img.classList.toggle('is-active', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
    }

    if (canHoverScrub) {
      // Desktop: position of the mouse across the image picks the photo
      media.addEventListener('mousemove', function (event) {
        var rect = media.getBoundingClientRect();
        var ratio = (event.clientX - rect.left) / rect.width;
        ratio = Math.min(0.999, Math.max(0, ratio));
        setIndex(Math.floor(ratio * count));
      });
      media.addEventListener('mouseleave', function () { setIndex(0); });
    } else {
      // Touch: the instant a finger lands on the photo it swaps to the
      // second image; lifting the finger (a normal tap) opens the product,
      // exactly like today, since nothing here blocks that click.
      // Nothing tracks finger movement, so scrolling the page or a
      // carousel with the same finger is never fought over.
      media.addEventListener('touchstart', function () { setIndex(1); }, { passive: true });
      media.addEventListener('touchend', function () { setIndex(0); }, { passive: true });
      media.addEventListener('touchcancel', function () { setIndex(0); }, { passive: true });
    }
  }
  qsa('[data-card-scrub]').forEach(initCardScrub);

  function initCardSwatches(card) {
    var swatches = qsa('[data-card-swatch]', card);
    if (!swatches.length) return;
    var firstImage = qs('.card__image', card);
    var link = qs('.card__link', card);
    if (!firstImage) return;
    var originalSrc = firstImage.getAttribute('src');
    var originalSrcset = firstImage.getAttribute('srcset');

    function preview(url) {
      if (!url) return;
      firstImage.removeAttribute('srcset');
      firstImage.setAttribute('src', url);
    }
    function reset() {
      if (originalSrcset) firstImage.setAttribute('srcset', originalSrcset);
      firstImage.setAttribute('src', originalSrc);
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener('mouseenter', function () { preview(swatch.getAttribute('data-swatch-image')); });
      swatch.addEventListener('mouseleave', reset);
      swatch.addEventListener('focus', function () { preview(swatch.getAttribute('data-swatch-image')); });
      swatch.addEventListener('blur', reset);
      swatch.addEventListener('click', function () {
        swatches.forEach(function (s) { s.classList.toggle('is-active', s === swatch); });
        var url = swatch.getAttribute('data-swatch-url');
        if (url && link) link.setAttribute('href', url);
      });
    });
  }
  qsa('[data-card-swatches]').forEach(function (row) { initCardSwatches(row.closest('[data-product-card]')); });

  /* ---------- Header: transparent over the home banner, smaller on scroll ---------- */

  var headerCleanup = null;
  function initHeader() {
    if (headerCleanup) headerCleanup();
    var header = qs('[data-header]');
    var docEl = document.documentElement;
    if (!header) { docEl.classList.remove('header-transparent'); return; }

    var firstSection = qs('#MainContent > .shopify-section');
    var transparent = header.getAttribute('data-transparent') === 'true' && !!(firstSection && qs('.hero, .product--wide', firstSection));
    var shrink = header.getAttribute('data-shrink') === 'true';
    var compact = false;
    var ticking = false;
    docEl.classList.toggle('header-transparent', transparent);

    function measure() {
      if (compact) return; // keep the full height as the reference
      docEl.style.setProperty('--header-height', header.offsetHeight + 'px');
    }

    function update() {
      var y = window.pageYOffset || docEl.scrollTop || 0;
      var engaged = header.contains(document.activeElement) || !!qs('details[open]', header);
      header.classList.toggle('is-transparent', transparent && y <= 10 && !engaged);
      if (shrink) {
        var next = compact ? y > 60 : y > 120; // small gap avoids flicker at the threshold
        if (next !== compact) {
          compact = next;
          header.classList.toggle('is-compact', compact);
        }
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }
    function onResize() { measure(); update(); }
    function onFocusOut() { setTimeout(update, 0); }

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', measure);
    header.addEventListener('toggle', update, true);
    header.addEventListener('focusin', update);
    header.addEventListener('focusout', onFocusOut);

    headerCleanup = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', measure);
      header.removeEventListener('toggle', update, true);
      header.removeEventListener('focusin', update);
      header.removeEventListener('focusout', onFocusOut);
      headerCleanup = null;
    };
  }
  initHeader();

  /* ---------- Announcement bar ---------- */

  function initAnnouncement(bar) {
    var slides = qsa('[data-announcement-slide]', bar);
    if (slides.length < 2) return;
    var index = 0;
    var timer = null;
    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;

    var track = qs('[data-announcement-track]', bar) || slides[0].parentNode;

    function show(next) {
      index = (next + slides.length) % slides.length;
      var target = slides[index];
      if (!target) return;
      track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    // Keep the rotation in step when someone swipes the bar by hand
    var syncTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        var closest = 0;
        var best = Infinity;
        slides.forEach(function (slide, i) {
          var delta = Math.abs((slide.offsetLeft - track.offsetLeft) - track.scrollLeft);
          if (delta < best) { best = delta; closest = i; }
        });
        index = closest;
      }, 120);
    }, { passive: true });
    function start() { if (!reducedMotion) { stop(); timer = setInterval(function () { show(index + 1); }, interval); } }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    var prev = qs('[data-announcement-prev]', bar);
    var next = qs('[data-announcement-next]', bar);
    if (prev) prev.addEventListener('click', function () { show(index - 1); start(); });
    if (next) next.addEventListener('click', function () { show(index + 1); start(); });
    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);
    start();
  }
  qsa('[data-announcement]').forEach(initAnnouncement);

  /* ---------- Product carousel ---------- */

  function initCarousel(root) {
    var rail = qs('[data-carousel-rail]', root);
    if (!rail) return;
    var prev = qs('[data-carousel-prev]', root);
    var next = qs('[data-carousel-next]', root);

    function step() {
      var item = qs('.fc-rail__item, [data-carousel-item]', rail);
      var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap) || 24;
      return item ? item.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }

    function updateArrows() {
      var maxScroll = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: reducedMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: reducedMotion ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }
  qsa('[data-carousel]').forEach(initCarousel);

  /* ---------- Before / after ---------- */

  function initBeforeAfter(frame) {
    if (frame.dataset.baReady) return;
    frame.dataset.baReady = '1';
    var handle = qs('[data-ba-handle]', frame);
    var pos = parseFloat(getComputedStyle(frame).getPropertyValue('--ba-pos')) || 50;
    var drag = null;

    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      frame.style.setProperty('--ba-pos', pos + '%');
      frame.classList.toggle('is-start', pos < 12);
      frame.classList.toggle('is-end', pos > 88);
      if (handle) {
        handle.setAttribute('aria-valuenow', String(Math.round(pos)));
        handle.setAttribute('aria-valuetext', Math.round(pos) + '%');
      }
    }
    function fromX(x) {
      var r = frame.getBoundingClientRect();
      return (x - r.left) / r.width * 100;
    }

    frame.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      drag = { id: e.pointerId, x: e.clientX, y: e.clientY, locked: e.pointerType !== 'touch', onHandle: !!(handle && handle.contains(e.target)) };
      /* mouse / pen: jump to the click and start dragging; touch: wait to see if the finger moves sideways */
      if (drag.locked) {
        if (!drag.onHandle) set(fromX(e.clientX));
        frame.classList.add('is-dragging');
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      }
    });
    frame.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (!drag.locked) {
        var dx = Math.abs(e.clientX - drag.x), dy = Math.abs(e.clientY - drag.y);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { drag = null; return; }   /* vertical swipe: let the page scroll */
        drag.locked = true;
        frame.classList.add('is-dragging');
        try { frame.setPointerCapture(e.pointerId); } catch (err) {}
      }
      set(fromX(e.clientX));
    });
    function end(e) {
      if (!drag || (e && e.pointerId !== drag.id)) return;
      /* a quick tap on touch (no drag) moves the handle there too */
      if (!drag.locked && e && e.type === 'pointerup' && !drag.onHandle) set(fromX(e.clientX));
      drag = null;
      frame.classList.remove('is-dragging');
    }
    frame.addEventListener('pointerup', end);
    frame.addEventListener('pointercancel', end);
    frame.addEventListener('lostpointercapture', function (e) { if (e.target === frame) end(e); });
    /* stop iOS from scrolling once a sideways drag has started */
    frame.addEventListener('touchmove', function (e) { if (drag && drag.locked) e.preventDefault(); }, { passive: false });
    frame.addEventListener('dragstart', function (e) { e.preventDefault(); });

    if (handle) {
      handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') set(pos - step);
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') set(pos + step);
        else if (e.key === 'Home') set(0);
        else if (e.key === 'End') set(100);
        else return;
        e.preventDefault();
      });
    }
    set(pos);
  }
  qsa('[data-before-after]').forEach(initBeforeAfter);

  /* ---------- Video section: staggered layout (reveal + play only while on screen) ---------- */

  function initVideoStagger(root) {
    if (root.dataset.vcReady) return;
    root.dataset.vcReady = '1';
    var items = qsa('[data-vc-reveal]', root);
    if (!('IntersectionObserver' in window)) return;
    root.classList.add('is-armed');
    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); reveal.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    var play = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.15 });
    items.forEach(function (item) {
      reveal.observe(item);
      var v = qs('video[autoplay]', item);
      if (v) play.observe(v);
    });
    /* in the theme editor, show everything at once */
    if (window.Shopify && window.Shopify.designMode) items.forEach(function (item) { item.classList.add('is-visible'); });
  }
  qsa('[data-vc-stagger]').forEach(initVideoStagger);

  /* ---------- Reviews: "Show more" ---------- */

  function initReviews(root) {
    var btn = qs('[data-reviews-more]', root);
    if (!btn || btn.dataset.ready) return;
    btn.dataset.ready = '1';
    btn.addEventListener('click', function () {
      var hidden = qsa('[data-review-more][hidden]', root);
      var step = Math.max(qsa('.review-card:not([hidden])', root).length, 6);
      hidden.slice(0, step).forEach(function (card) { card.hidden = false; });
      if (qsa('[data-review-more][hidden]', root).length === 0) btn.parentNode.hidden = true;
    });
  }
  qsa('[data-reviews]').forEach(initReviews);

  /* ---------- Story chapters ---------- */

  function initStory(root) {
    var tabs = qsa('[data-story-tab]', root);
    var panels = qsa('[data-story-panel]', root);
    var tabBar = qs('.story-split__tabs', root);
    if (!tabs.length || !panels.length) return;

    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var index = 0;
    var timer = null;

    function fillFor(tabIndex) {
      var tab = tabs[tabIndex];
      return tab ? qs('[data-story-fill]', tab) : null;
    }

    // Every fill but the active one is either fully done (already played)
    // or fully reset (still to come) - cleared of any leftover inline
    // style from an earlier round so nothing lingers between visits.
    function resetFills(exceptIndex) {
      tabs.forEach(function (tab, i) {
        var fill = qs('[data-story-fill]', tab);
        if (!fill || i === exceptIndex) return;
        fill.style.transitionDuration = '0ms';
        fill.style.width = i < exceptIndex ? '100%' : '0%';
        fill.classList.toggle('is-done', i < exceptIndex);
      });
    }

    function show(nextIndex) {
      index = ((nextIndex % tabs.length) + tabs.length) % tabs.length;
      var value = tabs[index].getAttribute('data-story-tab');
      tabs.forEach(function (tab) {
        var active = tab.getAttribute('data-story-tab') === value;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-story-panel') === value;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      if (autoplay) startFill();
    }

    function startFill() {
      clearTimeout(timer);
      resetFills(index);
      var fill = fillFor(index);
      if (fill) {
        fill.classList.remove('is-done');
        if (reducedMotion) {
          fill.style.transitionDuration = '0ms';
          fill.style.width = '100%';
        } else {
          fill.style.transitionDuration = '0ms';
          fill.style.width = '0%';
          // Two animation frames (not just a reflow) so the browser reliably
          // treats the 0% and 100% as separate steps and actually animates
          // between them - a single offsetWidth reflow is skipped by some
          // mobile browsers, which was making the bar jump straight to full.
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              fill.style.transitionDuration = interval + 'ms';
              fill.style.width = '100%';
            });
          });
        }
      }
      timer = setTimeout(function () { show(index + 1); }, interval);
    }

    function stop() {
      clearTimeout(timer);
      var fill = fillFor(index);
      if (fill) fill.style.transitionDuration = '0ms';
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { show(i); });
      tab.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var next = (i + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[next].focus();
        show(next);
      });
    });

    // Touch: swipe left/right on the panel to move between chapters.
    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener('touchstart', function (event) {
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (event) {
      var touch = event.changedTouches[0];
      var dx = touch.clientX - touchStartX;
      var dy = touch.clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      show(index + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (autoplay) {
      // Pausing on hover only makes sense over the small tab bar itself -
      // scoping it to the whole section meant just moving the mouse near
      // the photo (almost the entire block) froze the bar before it could
      // ever visibly fill.
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      tabs.forEach(function (tab) {
        if (canHover) {
          tab.addEventListener('mouseenter', stop);
          tab.addEventListener('mouseleave', function () { startFill(); });
        }
        // Keyboard focus only (focus-visible), so a mouse click on a number
        // does not leave the timer paused afterwards.
        tab.addEventListener('focusin', function () {
          if (tab.matches && tab.matches(':focus-visible')) stop();
        });
        tab.addEventListener('focusout', function () { startFill(); });
      });
      startFill();
    }
  }
  qsa('[data-story]').forEach(initStory);

  /* ---------- Click-to-load video (no third-party requests before play) ---------- */

  var VIDEO_ID = /^[A-Za-z0-9_-]{1,32}$/;
  function initLiteVideo(wrapper) {
    var button = qs('[data-lite-video-play]', wrapper);
    if (!button) return;
    button.addEventListener('click', function () {
      var provider = wrapper.getAttribute('data-provider');
      var id = wrapper.getAttribute('data-video-id') || '';
      if (!VIDEO_ID.test(id)) return;
      var src;
      if (provider === 'youtube') {
        src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&playsinline=1';
      } else if (provider === 'vimeo') {
        src = 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=1&dnt=1';
      } else {
        return;
      }
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', src);
      iframe.setAttribute('title', wrapper.getAttribute('data-title') || 'Video');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      while (wrapper.firstChild) wrapper.removeChild(wrapper.firstChild);
      wrapper.appendChild(iframe);
    });
  }
  qsa('[data-lite-video]').forEach(initLiteVideo);

  /* ---------- Product page extras: date, countdown, delivery ---------- */

  function initUpdateNote(note) {
    var el = qs('[data-update-date]', note);
    if (!el) return;
    // Always show today's date in Central European Time, whatever the
    // visitor's own timezone is.
    try {
      el.textContent = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Paris', day: 'numeric', month: 'long', year: 'numeric'
      }).format(new Date());
    } catch (e) { /* server-rendered date stays */ }
  }
  qsa('[data-update-note]').forEach(initUpdateNote);

  function initCountdown(root) {
    var clock = qs('[data-countdown-clock]', root);
    if (!clock) return;
    var minutes = parseInt(root.getAttribute('data-minutes'), 10) || 30;
    var total = minutes * 60 * 1000;
    var key = 'ss-countdown';
    var endsAt;

    // Starts the moment the visitor lands, and keeps running across pages
    // for this browsing session instead of restarting on every click.
    try {
      var stored = sessionStorage.getItem(key);
      endsAt = stored ? parseInt(stored, 10) : 0;
      if (!endsAt || endsAt < Date.now()) {
        endsAt = Date.now() + total;
        sessionStorage.setItem(key, String(endsAt));
      }
    } catch (e) {
      endsAt = Date.now() + total;
    }

    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = Math.max(0, endsAt - Date.now());
      var h = Math.floor(left / 3600000);
      var m = Math.floor((left % 3600000) / 60000);
      var sec = Math.floor((left % 60000) / 1000);
      clock.textContent = (h > 0 ? pad(h) + ':' : '') + pad(m) + ':' + pad(sec);
      if (left <= 0) clearInterval(timer);
    }
    tick();
    var timer = setInterval(tick, 1000);
  }
  qsa('[data-countdown]').forEach(initCountdown);

  function initDelivery(root) {
    var dispatchDays = parseInt(root.getAttribute('data-dispatch-days'), 10);
    var minDays = parseInt(root.getAttribute('data-min-days'), 10) || 5;
    var maxDays = parseInt(root.getAttribute('data-max-days'), 10) || 10;
    if (isNaN(dispatchDays)) dispatchDays = 1;

    function addWorkingDays(date, days) {
      var out = new Date(date.getTime());
      var added = 0;
      while (added < days) {
        out.setDate(out.getDate() + 1);
        var day = out.getDay();
        if (day !== 0 && day !== 6) added++;
      }
      return out;
    }
    function fmt(date) {
      try {
        return new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', {
          day: 'numeric', month: 'short'
        }).format(date);
      } catch (e) {
        return date.getDate() + '/' + (date.getMonth() + 1);
      }
    }

    var today = new Date();
    var dispatch = addWorkingDays(today, dispatchDays);
    var arriveFrom = addWorkingDays(today, minDays);
    var arriveTo = addWorkingDays(today, maxDays);

    var slots = qsa('[data-delivery-date]', root);
    if (slots[0]) slots[0].textContent = fmt(today);
    if (slots[1]) slots[1].textContent = fmt(dispatch);
    if (slots[2]) slots[2].textContent = fmt(arriveFrom) + ' – ' + fmt(arriveTo);
  }
  qsa('[data-delivery]').forEach(initDelivery);

  /* ---------- Product ---------- */

  function initGallery(root) {
    var gallery = qs('[data-gallery]', root);
    var noop = { show: function () {} };
    if (!gallery) return noop;
    var stage = qs('.product__stage', gallery);
    var track = qs('[data-gallery-track]', gallery);
    if (!stage || !track) return noop;
    var slides = qsa('[data-media-id]', track);
    var thumbs = qsa('[data-thumb]', gallery);
    if (!slides.length) return noop;

    var index = Math.min(slides.length - 1, Math.max(0, parseInt(track.getAttribute('data-index'), 10) || 0));

    function width() { return stage.clientWidth || 1; }

    // Marks the current photo everywhere (thumbnails, screen readers, videos).
    function applyIndex() {
      track.style.setProperty('--index', String(index));
      var currentId = slides[index].getAttribute('data-media-id');
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if ('inert' in slide) slide.inert = !active;
        if (!active) qsa('video', slide).forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (thumb) {
        if (thumb.getAttribute('data-media-id') === currentId) thumb.setAttribute('aria-current', 'true');
        else thumb.removeAttribute('aria-current');
      });
    }

    // Slides (animated) to a photo and clears any leftover drag offset.
    function goTo(next) {
      index = Math.min(slides.length - 1, Math.max(0, next));
      track.classList.remove('is-dragging');
      track.style.setProperty('--drag', '0px');
      applyIndex();
    }

    function show(mediaId) {
      if (!mediaId) return;
      var id = String(mediaId);
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === id) { goTo(i); return; }
      }
    }

    // Arrows and thumbnails; the arrows loop at the ends.
    function step(delta) {
      if (slides.length < 2) return;
      goTo(((index + delta) % slides.length + slides.length) % slides.length);
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.getAttribute('data-media-id')); });
    });
    var prevButton = qs('[data-gallery-prev]', gallery);
    var nextButton = qs('[data-gallery-next]', gallery);
    if (prevButton) prevButton.addEventListener('click', function () { step(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { step(1); });

    applyIndex();
    if (slides.length < 2) return { show: show };

    // ---- Drag to slide: the photos follow the finger (or mouse) and can
    // be left half-way; on release they settle on the nearest photo. ----

    // How far the strip currently is from where photo `index` rests. Non-zero
    // only while a slide animation is still running.
    function currentOffset() {
      var matrix = getComputedStyle(track).transform;
      if (!matrix || matrix === 'none') return 0;
      return new DOMMatrix(matrix).m41 + index * width();
    }

    var drag = null;

    stage.addEventListener('dragstart', function (event) { event.preventDefault(); });

    function beginDrag(x, y, time) {
      var base = currentOffset();
      drag = { x: x, y: y, base: base, decided: false, active: false, lastX: x, lastT: time, vx: 0 };
      if (Math.abs(base) > 1) {
        // Caught mid-slide: freeze right where it is and carry on from there.
        track.classList.add('is-dragging');
        track.style.setProperty('--drag', base + 'px');
      }
    }

    // Decides, from the very first movement, who owns the gesture. Returns
    // 'x' when the photos do (the caller must then stop the page from
    // scrolling), 'y' when it is a normal vertical scroll, '' while undecided.
    function moveDrag(x, y, time) {
      if (!drag) return 'y';
      var dx = x - drag.x;
      var dy = y - drag.y;

      if (!drag.decided) {
        if (Math.sqrt(dx * dx + dy * dy) < 4) return '';
        drag.decided = true;
        // Leans towards sideways: anything up to roughly 63 degrees off
        // horizontal counts as a swipe, so a slightly slanted thumb still
        // slides the photo. Clearly vertical movement scrolls the page.
        if (Math.abs(dx) >= Math.abs(dy) * 0.5) {
          drag.active = true;
          track.classList.add('is-dragging');
          stage.classList.add('is-grabbing');
        } else {
          abortDrag();
          return 'y';
        }
      }
      if (!drag.active) return 'y';

      var offset = drag.base + dx;
      // Past the first or last photo the strip resists, like a rubber band.
      if ((index === 0 && offset > 0) || (index === slides.length - 1 && offset < 0)) offset *= 0.35;
      track.style.setProperty('--drag', offset + 'px');

      var dt = time - drag.lastT;
      if (dt > 0) {
        drag.vx = 0.7 * ((x - drag.lastX) / dt) + 0.3 * drag.vx;
        drag.lastX = x;
        drag.lastT = time;
      }
      return 'x';
    }

    function endDrag(x) {
      if (!drag) return;
      var d = drag;
      drag = null;
      stage.classList.remove('is-grabbing');
      if (!d.active) {
        if (track.classList.contains('is-dragging')) goTo(index); // let a frozen slide finish
        return;
      }
      var offset = d.base + (x - d.x);
      var threshold = width() * 0.2;
      var direction = 0;
      if (offset <= -threshold || d.vx < -0.4) direction = 1;
      else if (offset >= threshold || d.vx > 0.4) direction = -1;
      goTo(index + direction);
    }

    function abortDrag() {
      if (!drag) return;
      drag = null;
      stage.classList.remove('is-grabbing');
      goTo(index);
    }

    var ignoreTarget = 'video, iframe, button, a';

    // Mouse (and pen): pointer events, with the pointer captured while sliding.
    stage.addEventListener('pointerdown', function (event) {
      if (event.pointerType === 'touch') return;
      if (event.button !== 0) return;
      if (event.target.closest && event.target.closest(ignoreTarget)) return;
      beginDrag(event.clientX, event.clientY, event.timeStamp);
      try { stage.setPointerCapture(event.pointerId); } catch (e) { /* not essential */ }
    });
    stage.addEventListener('pointermove', function (event) {
      if (event.pointerType === 'touch') return;
      moveDrag(event.clientX, event.clientY, event.timeStamp);
    });
    stage.addEventListener('pointerup', function (event) {
      if (event.pointerType === 'touch') return;
      try { stage.releasePointerCapture(event.pointerId); } catch (e) { /* not essential */ }
      endDrag(event.clientX);
    });
    stage.addEventListener('pointercancel', function (event) {
      if (event.pointerType === 'touch') return;
      abortDrag();
    });

    // Touch: touch events, because only these can tell the browser "this
    // one is mine, do not scroll the page". The touchmove listener is
    // deliberately not passive: once the swipe is recognised as sideways,
    // every further movement is cancelled, which locks the vertical scroll
    // for the rest of the gesture. Vertical gestures are left untouched.
    stage.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) { abortDrag(); return; }
      if (event.target.closest && event.target.closest(ignoreTarget)) { drag = null; return; }
      var touch = event.touches[0];
      beginDrag(touch.clientX, touch.clientY, event.timeStamp);
    }, { passive: true });

    stage.addEventListener('touchmove', function (event) {
      if (!drag) return;
      if (event.touches.length !== 1) { abortDrag(); return; }
      var touch = event.touches[0];
      var owner = moveDrag(touch.clientX, touch.clientY, event.timeStamp);
      if (owner === 'x' && event.cancelable) event.preventDefault();
    }, { passive: false });

    stage.addEventListener('touchend', function (event) {
      if (!drag) return;
      endDrag(event.changedTouches[0].clientX);
    }, { passive: true });

    stage.addEventListener('touchcancel', abortDrag, { passive: true });

    return { show: show };
  }

  /* Bundle totals in another currency. Checkout charges, per piece, the converted (rounded) unit
     price minus the automatic discount converted at Shopify's rate and rounded to the cent, so the
     page does the same sum with window.Shopify.currency.rate. tier.off is that per-piece discount
     in store-currency cents (custom.bundle_discount_2 / _3); without it the server estimate stays. */
  function moneyFormatter(sample, currency) {
    var m = sample && sample.match(/1([^0-9]?)234([^0-9])56/);
    if (!m) return function (cents) { return formatMoney(cents, currency); };
    var group = m[1]; var dec = m[2]; var tpl = sample.replace(m[0], '\u0000');
    return function (cents) {
      var neg = cents < 0; cents = Math.abs(Math.round(cents));
      var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, group);
      var frac = String(cents % 100); if (frac.length < 2) frac = '0' + frac;
      return (neg ? '-' : '') + tpl.replace('\u0000', whole + dec + frac);
    };
  }

  function localizeBundles(root, variants) {
    var currency = root.getAttribute('data-currency');
    var shopCurrency = root.getAttribute('data-shop-currency');
    if (!currency || !shopCurrency || currency === shopCurrency) return;
    var rate = window.Shopify && window.Shopify.currency ? Number(window.Shopify.currency.rate) : 0;
    if (!rate || !isFinite(rate)) return;
    var fmt = moneyFormatter(root.getAttribute('data-money-sample'), currency);
    variants.forEach(function (v) {
      Object.keys(v.tiers || {}).forEach(function (key) {
        var t = v.tiers[key];
        if (!t || !t.off || !t.qty || !t.unit) return;
        var total = t.qty * (t.unit - Math.round(t.off * rate));
        var compare = t.ref * t.qty;
        t.total = fmt(total);
        t.per = fmt(total / t.qty);
        t.compare = compare > total ? fmt(compare) : null;
      });
    });
    /* Repaint the server-rendered labels with the exact amounts */
    var idInput = qs('[data-variant-id]', root);
    var current = variants.filter(function (v) { return idInput && String(v.id) === String(idInput.value); })[0] || variants[0];
    qsa('[data-bundle-tier]', root).forEach(function (input) {
      var tier = current && current.tiers && current.tiers[input.getAttribute('data-bundle-tier')];
      var label = input.closest('.bundle__tier');
      if (!tier || !label || !tier.off) return;
      var total = qs('[data-tier-total]', label); if (total) total.textContent = tier.total;
      var per = qs('[data-tier-per]', label); if (per) per.textContent = tier.per;
      var cmp = qs('[data-tier-compare]', label);
      if (cmp) { cmp.textContent = tier.compare || ''; cmp.hidden = !tier.compare; }
    });
  }

  function initProduct(root) {
    var form = qs('form[data-product-form]', root);
    var dataEl = qs('[data-variant-json]', root);
    if (!form || !dataEl) return;

    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    localizeBundles(root, variants);

    var gallery = initGallery(root);
    var idInput = qs('[data-variant-id]', form);
    var qtyInput = qs('[data-quantity]', form);
    var fieldsets = qsa('[data-option-index]', root);
    var tierInputs = qsa('[data-bundle-tier]', root);
    var addButton = qs('[data-add-button]', form);
    var addLabel = qs('[data-add-label]', form);
    var buyButton = qs('[data-buy-now]', form);
    var buyLabel = qs('[data-buy-label]', form);
    var addPrice = qs('[data-add-price]', form);
    var errorEl = qs('[data-form-error]', form);
    var current = variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || variants[0];

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = qs('input[data-option-input]:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(options) {
      return variants.filter(function (v) {
        return v.options.every(function (value, i) { return options[i] === undefined || value === options[i]; });
      })[0];
    }

    function selectedTier() {
      var checked = tierInputs.filter(function (i) { return i.checked; })[0];
      return checked ? checked.getAttribute('data-bundle-tier') : null;
    }

    function setText(el, value) {
      if (!el) return;
      if (value) { el.textContent = value; el.hidden = false; }
      else { el.textContent = ''; el.hidden = true; }
    }

    function updateAvailability() {
      var selected = selectedOptions();
      fieldsets.forEach(function (fs, index) {
        qsa('input[data-option-input]', fs).forEach(function (input) {
          var test = selected.slice();
          test[index] = input.value;
          var possible = variants.some(function (v) {
            return v.available && v.options.every(function (value, i) { return value === test[i]; });
          });
          var label = fs.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !possible);
        });
        var label = qs('[data-option-value-label]', fs);
        if (label) label.textContent = selected[index] || '';
      });
    }

    function updateButton() {
      if (!addButton) return;
      var available = current && current.available;
      addButton.disabled = !available;
      if (buyButton) buyButton.disabled = !available;
      var unavailableText = !current ? (config.strings.unavailable || 'Unavailable') : (config.strings.soldOut || 'Sold out');
      if (addLabel) addLabel.textContent = available ? (config.strings.addToCart || 'Add to cart') : unavailableText;
      if (buyLabel) buyLabel.textContent = available ? (config.strings.buyNow || 'Buy now') : unavailableText;
      if (addPrice) {
        var tier = selectedTier();
        var total = current ? (tier && current.tiers && current.tiers[tier] ? current.tiers[tier].total : current.price) : '';
        addPrice.textContent = total || '';
        addPrice.hidden = !available || !total;
      }
    }

    function updatePrices() {
      if (!current) return;
      setText(qs('[data-price-current]', root), current.price);
      setText(qs('[data-price-compare]', root), current.compare);
      setText(qs('[data-price-save]', root), current.save);
      tierInputs.forEach(function (input) {
        var tier = current.tiers && current.tiers[input.getAttribute('data-bundle-tier')];
        var label = input.closest('.bundle__tier');
        if (!tier || !label) return;
        setText(qs('[data-tier-total]', label), tier.total);
        setText(qs('[data-tier-per]', label), tier.per);
        setText(qs('[data-tier-compare]', label), tier.compare);
      });
    }

    function onOptionChange() {
      current = findVariant(selectedOptions());
      if (current) {
        idInput.value = current.id;
        if (current.media) gallery.show(current.media);
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      if (errorEl) errorEl.hidden = true;
      updatePrices();
      updateAvailability();
      updateButton();
      root.dispatchEvent(new CustomEvent('ss:variant-change'));
    }

    fieldsets.forEach(function (fs) {
      fs.addEventListener('change', onOptionChange);
    });

    var pickGroups = qsa('[data-bundle-picks]', root);

    function syncPicks() {
      var tier = selectedTier();
      pickGroups.forEach(function (group) {
        group.hidden = group.getAttribute('data-bundle-picks') !== tier;
      });
    }

    tierInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var qty = parseInt(input.getAttribute('data-qty'), 10);
        if (qtyInput && qty > 0) qtyInput.value = String(qty);
        tierInputs.forEach(function (other) {
          var label = other.closest('.bundle__tier');
          if (label) label.classList.toggle('is-selected', other.checked);
        });
        syncPicks();
        updateButton();
      });
    });
    syncPicks();

    // Each row of a multi-item bundle resolves to its own variant, so the
    // customer can mix colours and sizes within one bundle.
    function bundleItems() {
      var tier = selectedTier();
      var group = pickGroups.filter(function (g) { return g.getAttribute('data-bundle-picks') === tier; })[0];
      if (!group) return null;
      var rows = qsa('[data-bundle-row]', group);
      if (!rows.length) return null;
      var items = [];
      for (var i = 0; i < rows.length; i++) {
        var chosen = qsa('[data-bundle-option]', rows[i]).map(function (select) { return select.value; });
        var match = variants.filter(function (v) {
          return v.options.every(function (value, idx) { return value === chosen[idx]; });
        })[0];
        if (!match || !match.available) return { error: rows[i] };
        items.push({ id: Number(match.id), quantity: 1 });
      }
      return items;
    }

    // Small floating card, bottom-right, shown only once the visitor has
    // scrolled all the way past the product section (not just the button).
    var stickyBar = qs('[data-sticky-buy]');
    if (stickyBar) {
      var stickyPrice = qs('[data-sticky-price]', stickyBar);
      var stickyAdd = qs('[data-sticky-add]', stickyBar);
      var stickyClose = qs('[data-sticky-close]', stickyBar);
      var stickyOptions = qsa('[data-sticky-option]', stickyBar);
      var dismissed = false;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var pastSection = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            stickyBar.hidden = dismissed || !pastSection;
            if (!pastSection) dismissed = false; // scrolling back up clears a dismiss
          });
        }, { rootMargin: '0px' }).observe(root);
      }

      if (stickyClose) {
        stickyClose.addEventListener('click', function () {
          dismissed = true;
          stickyBar.hidden = true;
        });
      }

      if (addButton) {
        if (stickyAdd) {
          stickyAdd.addEventListener('click', function () {
            if (typeof form.requestSubmit === 'function') form.requestSubmit(addButton);
            else addButton.click();
          });
        }

        // Each mini select drives the matching radio in the main option
        // picker, so it reuses all of the real variant/price/availability
        // logic instead of duplicating it.
        stickyOptions.forEach(function (select) {
          select.addEventListener('change', function () {
            var index = select.getAttribute('data-sticky-option');
            var radio = root.querySelector(
              '[data-option-index="' + index + '"] [data-option-input][value="' + CSS.escape(select.value) + '"]'
            );
            if (radio) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        root.addEventListener('ss:variant-change', function () {
          if (!current) return;
          if (stickyPrice) {
            var tier = selectedTier();
            var total = tier && current.tiers && current.tiers[tier] ? current.tiers[tier].total : current.price;
            stickyPrice.textContent = total;
          }
          stickyOptions.forEach(function (select) {
            var index = parseInt(select.getAttribute('data-sticky-option'), 10);
            var value = selectedOptions()[index];
            if (value) select.value = value;
          });
        });
      }
    }

    /* Which button sent the form: Buy now goes to checkout, Add to cart opens the cart. Older
       browsers without event.submitter fall back to the last button clicked. */
    var lastSubmitter = null;
    if (buyButton) buyButton.addEventListener('click', function () { lastSubmitter = buyButton; });
    if (addButton) addButton.addEventListener('click', function () { lastSubmitter = addButton; });

    form.addEventListener('submit', function (event) {
      if (!window.fetch) return; // falls back to a normal form post
      event.preventDefault();
      var submitter = event.submitter || lastSubmitter || addButton;
      lastSubmitter = null;
      var buying = !!buyButton && submitter === buyButton;
      if (!current || !current.available || !addButton) return;
      var quantity = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var items = bundleItems();
      if (items && items.error) {
        if (errorEl) {
          errorEl.textContent = config.strings.unavailable || 'Unavailable';
          errorEl.hidden = false;
        }
        items.error.scrollIntoView({ block: 'center', behavior: reducedMotion ? 'auto' : 'smooth' });
        return;
      }
      if (!items) items = [{ id: Number(current.id), quantity: quantity }];
      var busy = buying ? buyButton : addButton;
      busy.setAttribute('aria-busy', 'true');
      addButton.disabled = true;
      if (buyButton) buyButton.disabled = true;
      if (errorEl) errorEl.hidden = true;
      addToCart(items, buying)
        .then(function (data) {
          if (buying) {
            window.location.href = buyButton.value || '/checkout';
            return 'leaving';
          }
          afterAdd(data);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message || config.strings.error; errorEl.hidden = false; }
        })
        .then(function (state) {
          if (state === 'leaving') return; /* keep the button busy while the checkout loads */
          busy.removeAttribute('aria-busy');
          addButton.disabled = !(current && current.available);
          if (buyButton) buyButton.disabled = !(current && current.available);
        });
    });

    /* back from checkout (page restored from the browser cache): Buy now must not stay busy */
    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      if (buyButton) buyButton.removeAttribute('aria-busy');
      updateButton();
    });

    updateAvailability();
    updateButton();
    root.dispatchEvent(new CustomEvent('ss:variant-change'));
  }

  qsa('[data-product]').forEach(initProduct);

  /* ---------- Quick add (single-variant products) ---------- */

  function initQuickAdd(button) {
    button.addEventListener('click', function () {
      var id = Number(button.getAttribute('data-quick-add'));
      if (!id) return;
      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      addToCart([{ id: id, quantity: 1 }])
        .then(function (data) { if (!showAdded(data, button)) { refreshCartCount(); showToast(config.strings.added || 'Added to your cart.', true); } })
        .catch(function (err) { showToast(err.message || config.strings.error, false); })
        .then(function () { button.removeAttribute('aria-busy'); button.disabled = false; });
    });
  }
  qsa('[data-quick-add]').forEach(initQuickAdd);

  /* ---------- Quick picker (Complete the look items with variants) ---------- */

  function initQuickPick(panel) {
    if (panel.dataset.qpReady) return;
    panel.dataset.qpReady = '1';
    var add = qs('[data-qp-add]', panel);
    var selects = qsa('[data-qp-option]', panel);
    var variants = [];
    try { variants = JSON.parse(qs('[data-qp-variants]', panel).textContent); } catch (e) {}

    function current() {
      var chosen = selects.map(function (s) { return s.value; });
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < chosen.length; j++) if (v.options[j] !== chosen[j]) { ok = false; break; }
        if (ok) return v;
      }
      return null;
    }
    function sync() {
      var v = current();
      add.disabled = !v || !v.available;
      add.textContent = !v ? add.getAttribute('data-label-unavailable') : v.available ? add.getAttribute('data-label-add') : add.getAttribute('data-label-sold');
    }

    selects.forEach(function (s) { s.addEventListener('change', sync); });
    add.addEventListener('click', function () {
      var v = current();
      if (!v || !v.available) return;
      add.disabled = true;
      add.setAttribute('aria-busy', 'true');
      addToCart([{ id: v.id, quantity: 1 }])
        .then(function (data) { if (!showAdded(data, add)) { refreshCartCount(); showToast(config.strings.added || 'Added to your cart.', true); } })
        .catch(function (err) { showToast(err.message || config.strings.error, false); })
        .then(function () { add.removeAttribute('aria-busy'); sync(); });
    });
    sync();
  }
  qsa('[data-quick-pick]').forEach(initQuickPick);

  /* ---------- Collection filters and sorting ---------- */

  qsa('[data-facet-form]').forEach(function (form) {
    function submit() {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.submit();
    }
    form.addEventListener('submit', function () {
      // Keep URLs clean: skip empty price inputs.
      qsa('input[type="number"]', form).forEach(function (input) {
        if (input.value === '') input.disabled = true;
      });
    });
    qsa('[data-sort], [data-facet-checkbox]', form).forEach(function (input) {
      input.addEventListener('change', submit);
    });
  });

  /* ---------- Cart page: update on quantity change ---------- */

  qsa('[data-cart-form]').forEach(function (form) {
    var updateButton = qs('[data-cart-update]', form);
    var timer;
    qsa('[data-cart-qty]', form).forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (updateButton && typeof form.requestSubmit === 'function') form.requestSubmit(updateButton);
          else if (updateButton) updateButton.click();
        }, 400);
      });
    });
  });
  /* ---------- Order tracking page ---------- */

  /* 17TRACK's free widget (externalcall.js) is loaded once, only when a number is tracked. */
  var trackingScript = null;
  function load17track() {
    if (window.YQV5 && window.YQV5.trackSingle) return Promise.resolve(window.YQV5);
    if (trackingScript) return trackingScript;
    trackingScript = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      var timer = setTimeout(fail, 12000);
      function fail() { clearTimeout(timer); trackingScript = null; reject(new Error('17TRACK widget unavailable')); }
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = function () {
        clearTimeout(timer);
        if (window.YQV5 && window.YQV5.trackSingle) resolve(window.YQV5); else fail();
      };
      script.onerror = fail;
      document.head.appendChild(script);
    });
    return trackingScript;
  }

  function trackingLink(provider, number, lang, carrier, custom) {
    var n = encodeURIComponent(number);
    if (provider === 'parcelsapp_tab') {
      var pl = ['en', 'de', 'fr', 'es', 'it', 'pt', 'ru', 'pl', 'nl', 'tr'].indexOf(lang) > -1 ? lang : 'en';
      return 'https://parcelsapp.com/' + pl + '/tracking/' + n;
    }
    if (provider === 'custom_tab' && custom) {
      return custom.indexOf('{number}') > -1 ? custom.split('{number}').join(n) : custom + n;
    }
    return 'https://t.17track.net/' + lang + '#nums=' + n + (carrier ? '&fc=' + encodeURIComponent(carrier) : '');
  }

  function initTracking(root) {
    if (root.dataset.trackingReady) return;
    root.dataset.trackingReady = '1';
    var form = qs('[data-tracking-form]', root);
    var input = qs('[data-tracking-input]', root);
    var error = qs('[data-tracking-error]', root);
    var result = qs('[data-tracking-result]', root);
    var frame = qs('[data-tracking-frame]', root);
    var status = qs('[data-tracking-status]', root);
    var current = qs('[data-tracking-current]', root);
    var external = qs('[data-tracking-external]', root);
    if (!form || !input || !frame) return;
    var strings = {};
    try { strings = JSON.parse(qs('[data-tracking-strings]', root).textContent); } catch (e) { strings = {}; }
    var provider = root.dataset.provider || '17track_embed';
    var lang = root.dataset.lang || 'en';
    var carrier = root.dataset.carrier || '';
    var custom = root.dataset.customUrl || '';
    var height = Math.min(800, Math.max(400, parseInt(root.dataset.height, 10) || 560));
    var run = 0;

    function clean(value) { return String(value || '').replace(/[\s ]+/g, '').toUpperCase(); }
    function showError(message) {
      error.textContent = message || '';
      error.hidden = !message;
      if (message) input.setAttribute('aria-invalid', 'true'); else input.removeAttribute('aria-invalid');
    }
    function remember(number) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('tracking', number);
        window.history.replaceState(window.history.state, '', url.toString());
      } catch (e) { /* old browsers: the URL just stays as it is */ }
    }
    function settle(mine) {
      /* keep the spinner until the widget's frame has loaded (or give up waiting after a while) */
      var tries = 0;
      function done() { if (mine === run) frame.removeAttribute('aria-busy'); }
      (function look() {
        var iframe = qs('iframe', frame);
        if (iframe) { iframe.addEventListener('load', done); setTimeout(done, 8000); return; }
        if (++tries > 20) { done(); return; }
        setTimeout(look, 50);
      })();
    }

    function track(raw, fromUser) {
      var number = clean(raw);
      if (!number) { showError(strings.empty); input.focus(); return; }
      if (!/^[A-Z0-9-]{5,40}$/.test(number)) { showError(strings.invalid); input.focus(); return; }
      showError('');
      input.value = number;
      remember(number);
      var link = trackingLink(provider, number, lang, carrier, custom);
      external.href = link;
      current.textContent = number;
      result.hidden = false;
      var mine = ++run;

      if (provider !== '17track_embed') {
        frame.innerHTML = '';
        frame.removeAttribute('aria-busy');
        frame.classList.add('tracking__frame--compact');
        status.textContent = '';
        /* a new tab can only open from the shopper's own click, not from a link with ?tracking= */
        if (fromUser) { window.open(link, '_blank', 'noopener'); status.textContent = strings.opened || ''; }
        return;
      }

      frame.classList.remove('tracking__frame--compact');
      frame.innerHTML = '';
      frame.setAttribute('aria-busy', 'true');
      status.textContent = strings.loading || '';
      if (fromUser) result.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
      load17track().then(function (api) {
        if (mine !== run) return;
        frame.innerHTML = '';
        api.trackSingle({ YQ_ContainerId: frame.id, YQ_Height: height, YQ_Fc: carrier || '0', YQ_Lang: lang, YQ_Num: number });
        status.textContent = '';
        settle(mine);
      }).catch(function () {
        if (mine !== run) return;
        frame.removeAttribute('aria-busy');
        frame.classList.add('tracking__frame--compact');
        status.textContent = strings.failed || '';
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      track(input.value, true);
    });
    input.addEventListener('input', function () { if (!error.hidden) showError(''); });
    qsa('[data-tracking-number]', root).forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.getAttribute('data-tracking-number');
        track(input.value, true);
      });
    });

    var params = new URLSearchParams(window.location.search);
    var start = params.get('tracking') || params.get('nums') || params.get('number');
    if (start) track(start, false);
  }
  qsa('[data-tracking]').forEach(initTracking);

  /* ---------- Reviews count: smooth jump to the anchored section ---------- */

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.rating__count[href^="#"]');
    if (!link) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* ---------- Mystery gift popup (sections/mystery-gift.liquid) ---------- */

  var GIFT_KEY = 'ss-mystery-gift';
  /* Throwaway inbox providers: an address there can't be trusted to stay reachable. */
  var GIFT_DISPOSABLE = ('mailinator.com guerrillamail.com guerrillamail.net sharklasers.com grr.la 10minutemail.com 10minutemail.net '
    + 'tempmail.com temp-mail.org temp-mail.io tempmail.net tempmailo.com tempr.email yopmail.com yopmail.fr yopmail.net '
    + 'trashmail.com trashmail.de throwawaymail.com getnada.com nada.email dispostable.com maildrop.cc mailnesia.com '
    + 'mintemail.com fakeinbox.com spamgourmet.com mohmal.com emailondeck.com moakt.com tmail.ws tmpmail.org tmpmail.net '
    + 'burnermail.io mailcatch.com inboxkitten.com discard.email 33mail.com spambox.us mail.tm mytemp.email luxusmail.org').split(' ');
  /* Common domain typos and their fix. */
  var GIFT_TYPOS = {
    'gmial.com': 'gmail.com', 'gmai.com': 'gmail.com', 'gamil.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmaill.com': 'gmail.com',
    'gnail.com': 'gmail.com', 'gmail.co': 'gmail.com', 'gmail.con': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com',
    'gmail.cmo': 'gmail.com', 'gmail.comm': 'gmail.com', 'googlemail.con': 'googlemail.com',
    'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com', 'hotmai.com': 'hotmail.com', 'hotmail.co': 'hotmail.com',
    'hotmail.con': 'hotmail.com', 'hotmil.com': 'hotmail.com',
    'outlok.com': 'outlook.com', 'outloo.com': 'outlook.com', 'outlook.co': 'outlook.com', 'outlook.con': 'outlook.com',
    'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com', 'yahoo.co': 'yahoo.com', 'yahoo.con': 'yahoo.com',
    'icloud.co': 'icloud.com', 'icloud.con': 'icloud.com', 'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com',
    'live.con': 'live.com'
  };
  function giftCheckEmail(address) {
    var value = (address || '').trim().toLowerCase();
    var match = /^[a-z0-9.!#$%&'*+\/=?^_`{|}~-]+@([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+)$/.exec(value);
    if (!match || value.length > 254 || value.indexOf('..') !== -1 || value.charAt(0) === '.' || value.indexOf('.@') !== -1) return { ok: false, reason: 'invalid' };
    var domain = match[1];
    var tld = domain.split('.').pop();
    if (!/^[a-z]{2,24}$/.test(tld)) return { ok: false, reason: 'invalid' };
    for (var i = 0; i < GIFT_DISPOSABLE.length; i++) {
      var d = GIFT_DISPOSABLE[i];
      if (domain === d || domain.slice(-(d.length + 1)) === '.' + d) return { ok: false, reason: 'disposable' };
    }
    if (GIFT_TYPOS[domain]) return { ok: true, value: value, suggestion: value.replace(/@.*$/, '@' + GIFT_TYPOS[domain]) };
    return { ok: true, value: value };
  }
  function giftRead() {
    try { return JSON.parse(window.localStorage.getItem(GIFT_KEY)) || {}; } catch (e) { return {}; }
  }
  function giftWrite(value) {
    try { window.localStorage.setItem(GIFT_KEY, JSON.stringify(value)); } catch (e) { /* private mode */ }
  }

  function initGift(root) {
    if (!root || root.getAttribute('data-gift-ready') === 'true') return;
    root.setAttribute('data-gift-ready', 'true');

    var panel = qs('[data-gift-panel]', root);
    var card = qs('[data-gift-card]', root);
    var canvas = qs('[data-gift-foil]', root);
    var lead = qs('[data-gift-lead]', root);
    var form = qs('[data-gift-form]', root);
    var email = qs('[data-gift-email]', root);
    var error = qs('[data-gift-error]', root);
    var suggest = qs('[data-gift-suggest]', root);
    var suggestButton = qs('[data-gift-suggest-button]', root);
    var sent = qs('[data-gift-sent]', root);
    var byEmail = root.getAttribute('data-delivery') === 'email';
    var dismissedSuggestion = '';
    var submit = qs('[data-gift-submit]', root);
    var copy = qs('[data-gift-copy]', root);
    var teaser = qs('[data-gift-teaser]');
    var stepEmail = qs('[data-gift-step="email"]', root);
    var stepDone = qs('[data-gift-step="done"]', root);
    var preview = root.getAttribute('data-preview') === 'true';
    var code = root.getAttribute('data-code') || '';
    var delay = (parseInt(root.getAttribute('data-delay'), 10) || 0) * 1000;
    var snoozeDays = parseInt(root.getAttribute('data-snooze-days'), 10) || 7;
    var state = preview ? {} : giftRead();
    var isOpen = false;
    var revealed = false;
    var done = state.s === 'subscribed';
    var lastFocus = null;
    var timer = null;
    var foilReady = false;

    function showTeaser(show) {
      if (teaser) teaser.hidden = !show || preview;
    }

    /* Scratch layer */
    var ctx = canvas && canvas.getContext ? canvas.getContext('2d') : null;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var drawing = false;
    var last = null;
    var moves = 0;

    function drawFoil() {
      if (!ctx) return;
      var w = card.clientWidth;
      var h = card.clientHeight;
      if (!w || !h) return;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      var grad = ctx.createLinearGradient(0, 0, w, h);
      grad.addColorStop(0, '#1b1b1b');
      grad.addColorStop(0.5, '#3a3a3a');
      grad.addColorStop(1, '#141414');
      ctx.fillStyle = grad;
      ctx.fillRect(0, 0, w, h);
      ctx.strokeStyle = 'rgba(255,255,255,0.06)';
      ctx.lineWidth = 1;
      for (var x = -h; x < w; x += 7) {
        ctx.beginPath(); ctx.moveTo(x, h); ctx.lineTo(x + h, 0); ctx.stroke();
      }
      ctx.strokeStyle = 'rgba(255,255,255,0.35)';
      ctx.strokeRect(10.5, 10.5, w - 21, h - 21);
      /* gift icon */
      var s = Math.min(w, h) * 0.2;
      var cx = w / 2;
      var cy = h / 2 - s * 0.45;
      ctx.save();
      ctx.translate(cx - s / 2, cy - s / 2);
      ctx.scale(s / 24, s / 24);
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 1.4;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      ctx.strokeRect(3.5, 9, 17, 11.5);
      ctx.strokeRect(2.5, 6.5, 19, 2.5);
      ctx.beginPath(); ctx.moveTo(12, 6.5); ctx.lineTo(12, 20.5); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(12, 6.5); ctx.bezierCurveTo(10.5, 3, 7, 2.6, 7, 4.6); ctx.bezierCurveTo(7, 6.2, 10, 6.5, 12, 6.5); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(12, 6.5); ctx.bezierCurveTo(13.5, 3, 17, 2.6, 17, 4.6); ctx.bezierCurveTo(17, 6.2, 14, 6.5, 12, 6.5); ctx.stroke();
      ctx.restore();
      var label = (root.getAttribute('data-foil-text') || '').toUpperCase();
      if (label) {
        var font = window.getComputedStyle(document.body).fontFamily || 'sans-serif';
        var size = Math.max(11, Math.min(14, w / 26));
        ctx.font = '500 ' + size + 'px ' + font;
        ctx.fillStyle = '#ffffff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        if ('letterSpacing' in ctx) ctx.letterSpacing = (size * 0.28) + 'px';
        ctx.fillText(label, cx, h / 2 + s * 0.55);
      }
      foilReady = true;
    }

    function point(event) {
      var rect = canvas.getBoundingClientRect();
      return { x: event.clientX - rect.left, y: event.clientY - rect.top };
    }

    function scratch(from, to) {
      ctx.globalCompositeOperation = 'destination-out';
      ctx.strokeStyle = '#000';
      ctx.lineWidth = Math.max(28, card.clientWidth / 9);
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      ctx.beginPath();
      ctx.moveTo(from.x, from.y);
      ctx.lineTo(to.x + 0.01, to.y);
      ctx.stroke();
    }

    function clearedShare() {
      try {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var step = 4 * 24;
        var clear = 0;
        var total = 0;
        for (var i = 3; i < data.length; i += step) {
          total += 1;
          if (data[i] < 64) clear += 1;
        }
        return total ? clear / total : 0;
      } catch (e) { return 0; }
    }

    if (ctx) {
      canvas.addEventListener('pointerdown', function (event) {
        if (revealed) return;
        drawing = true;
        last = point(event);
        scratch(last, last);
        try { canvas.setPointerCapture(event.pointerId); } catch (e) { /* ignore */ }
        event.preventDefault();
      });
      canvas.addEventListener('pointermove', function (event) {
        if (!drawing || revealed) return;
        var next = point(event);
        scratch(last, next);
        last = next;
        moves += 1;
        if (moves % 8 === 0 && clearedShare() > 0.45) reveal();
      });
      var stop = function () {
        if (!drawing) return;
        drawing = false;
        if (!revealed && clearedShare() > 0.45) reveal();
      };
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
    }

    function setStep(step) {
      stepEmail.hidden = step !== 'email';
      stepDone.hidden = step !== 'done';
      root.classList.toggle('is-done', step === 'done');
    }

    function reveal() {
      if (revealed) return;
      revealed = true;
      root.classList.add('is-revealed');
      if (done) {
        setStep('done');
        return;
      }
      if (lead && root.getAttribute('data-revealed-lead')) lead.textContent = root.getAttribute('data-revealed-lead');
      setStep('email');
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        setTimeout(function () { email.focus(); }, 250);
      }
    }

    function sendToKlaviyo(address) {
      var key = root.getAttribute('data-klaviyo-key');
      var list = root.getAttribute('data-klaviyo-list');
      if (!key || !list) return Promise.reject(new Error('no-klaviyo'));
      return fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(key), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: root.getAttribute('data-source') || 'Mystery gift popup',
              profile: { data: { type: 'profile', attributes: { email: address } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }).then(function (response) {
        if (!response.ok) throw new Error('klaviyo-' + response.status);
      });
    }

    function sendToShopify(address) {
      var body = new URLSearchParams();
      body.append('form_type', 'customer');
      body.append('utf8', '✓');
      body.append('contact[email]', address);
      body.append('contact[tags]', 'newsletter,mystery-gift');
      return fetch((config.routes.root_url || '/').replace(/\/?$/, '/') + 'contact', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      });
    }

    function applyCode() {
      if (byEmail || root.getAttribute('data-apply') !== 'true' || !code) return;
      fetch((config.routes.root_url || '/').replace(/\/?$/, '/') + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
        .catch(function () {});
    }

    function showError(reason) {
      error.textContent = error.getAttribute(reason === 'disposable' ? 'data-disposable' : 'data-invalid') || '';
      error.hidden = false;
      email.setAttribute('aria-invalid', 'true');
      email.focus();
    }
    function hideHints() {
      error.hidden = true;
      email.setAttribute('aria-invalid', 'false');
      if (suggest) suggest.hidden = true;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var check = giftCheckEmail(email.value);
      if (!check.ok) { if (suggest) suggest.hidden = true; showError(check.reason); return; }
      if (check.suggestion && suggest && dismissedSuggestion !== check.value) {
        /* Ask once; submitting the same address again keeps it as typed. */
        dismissedSuggestion = check.value;
        suggestButton.textContent = check.suggestion + '?';
        suggestButton.setAttribute('data-value', check.suggestion);
        suggest.hidden = false;
        return;
      }
      hideHints();
      var address = check.value;
      submit.setAttribute('aria-busy', 'true');
      var klaviyo = sendToKlaviyo(address).catch(function (err) {
        if (window.console && err && err.message !== 'no-klaviyo') console.warn('[Mystery gift] Klaviyo:', err.message);
      });
      /* Always saved in Shopify too: a tagged customer, so the code can be limited to that segment. */
      var shopify = sendToShopify(address).catch(function () {});
      Promise.all([klaviyo, shopify]).then(function () {
        submit.removeAttribute('aria-busy');
        done = true;
        if (!preview) giftWrite({ s: 'subscribed', t: Date.now() });
        if (sent) sent.textContent = (sent.getAttribute('data-template') || '').replace('[email]', address);
        if (!byEmail) applyCode();
        setStep('done');
        showTeaser(false);
        var target = copy || qs('.gift__shop', root);
        if (target) target.focus();
      });
    });
    if (suggestButton) suggestButton.addEventListener('click', function () {
      email.value = suggestButton.getAttribute('data-value') || email.value;
      suggest.hidden = true;
      email.focus();
    });
    email.addEventListener('input', function () {
      if (!error.hidden || (suggest && !suggest.hidden)) hideHints();
    });

    if (copy) {
      copy.addEventListener('click', function () {
        var original = copy.getAttribute('data-label') || copy.textContent;
        copy.setAttribute('data-label', original);
        var finish = function () {
          copy.textContent = copy.getAttribute('data-copied') || original;
          setTimeout(function () { copy.textContent = original; }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(finish, finish);
        } else {
          var range = document.createRange();
          range.selectNodeContents(qs('[data-gift-code]', root));
          var selection = window.getSelection();
          selection.removeAllRanges();
          selection.addRange(range);
          try { document.execCommand('copy'); } catch (e) { /* ignore */ }
          finish();
        }
      });
    }

    var revealLink = qs('[data-gift-reveal]', root);
    if (revealLink) revealLink.addEventListener('click', function () {
      if (ctx) { ctx.clearRect(0, 0, canvas.width, canvas.height); }
      reveal();
    });

    function onKey(event) {
      if (!isOpen) return;
      if (event.key === 'Escape') { close(); return; }
      if (event.key !== 'Tab') return;
      var items = focusables(panel);
      if (!items.length) return;
      var first = items[0];
      var lastItem = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); lastItem.focus(); }
      else if (!event.shiftKey && document.activeElement === lastItem) { event.preventDefault(); first.focus(); }
    }

    function open() {
      if (isOpen) return;
      if (document.documentElement.classList.contains('cart-drawer-open')) {
        timer = setTimeout(open, 4000);
        return;
      }
      clearTimeout(timer);
      isOpen = true;
      lastFocus = document.activeElement;
      root.hidden = false;
      showTeaser(false);
      document.documentElement.classList.add('gift-open');
      if (done) { revealed = false; reveal(); }
      requestAnimationFrame(function () {
        if (!foilReady && !revealed) drawFoil();
        root.classList.add('is-open');
        panel.focus();
      });
      document.addEventListener('keydown', onKey);
    }

    function close() {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('gift-open');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { if (!isOpen) root.hidden = true; }, reducedMotion ? 0 : 350);
      if (!done) {
        if (!preview) giftWrite({ s: 'dismissed', t: Date.now() });
        showTeaser(true);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    qsa('[data-gift-close]', root).forEach(function (button) { button.addEventListener('click', close); });
    if (teaser) teaser.addEventListener('click', open);
    window.addEventListener('resize', function () { if (isOpen && !revealed) drawFoil(); });

    root.giftOpen = open;
    root.giftClose = close;

    if (preview) { open(); return; }
    if (done) return;
    if (state.s === 'dismissed' && Date.now() - (state.t || 0) < snoozeDays * 86400000) {
      showTeaser(true);
      return;
    }
    timer = setTimeout(open, delay);
    if (root.getAttribute('data-exit-intent') === 'true' && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var onLeave = function (event) {
        if (event.clientY <= 0 && !event.relatedTarget) {
          document.removeEventListener('mouseout', onLeave);
          open();
        }
      };
      setTimeout(function () { document.addEventListener('mouseout', onLeave); }, 3000);
    }
  }
  qsa('[data-gift]').forEach(initGift);

  document.addEventListener('shopify:section:select', function (event) {
    var gift = qs('[data-gift]', event.target);
    if (gift && gift.giftOpen) gift.giftOpen();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var gift = qs('[data-gift]', event.target);
    if (gift && gift.giftClose) gift.giftClose();
  });

  /* ---------- Theme editor: re-run when a section is reloaded ---------- */

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target;
    initHeader();
    qsa('[data-announcement]', root).forEach(initAnnouncement);
    qsa('[data-lite-video]', root).forEach(initLiteVideo);
    qsa('[data-product]', root).forEach(initProduct);
    qsa('[data-quick-add]', root).forEach(initQuickAdd);
    qsa('[data-quick-pick]', root).forEach(initQuickPick);
    qsa('[data-carousel]', root).forEach(initCarousel);
    qsa('[data-story]', root).forEach(initStory);
    qsa('[data-before-after]', root).forEach(initBeforeAfter);
    qsa('[data-vc-stagger]', root).forEach(initVideoStagger);
    qsa('[data-reviews]', root).forEach(initReviews);
    qsa('[data-tracking]', root).forEach(initTracking);
    qsa('[data-gift]', root).forEach(initGift);
    qsa('[data-card-scrub]', root).forEach(initCardScrub);
    qsa('[data-card-swatches]', root).forEach(function (row) { initCardSwatches(row.closest('[data-product-card]')); });
  });
  document.addEventListener('shopify:section:unload', function () { setTimeout(initHeader, 0); });
  document.addEventListener('shopify:section:reorder', initHeader);
})();
